<ion-content class="ion-padding s-super-social">
  <section>
    <usucampeao-header title="Cadastrar moradores com renda"></usucampeao-header>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <usucampeao-input controlName="nome" label="Nome*" type="text">
        <span usu-error>{{ gerarMensagemErro('nome')}}</span>
      </usucampeao-input>

      <usucampeao-input controlName="rg" label="RG*" type="text">
        <span usu-error>{{ gerarMensagemErro('rg')}}</span>
      </usucampeao-input>

      <usucampeao-input controlName="cpf" label="CPF*" type="tel" mask="000.000.000-00" [readonly]="!!moradorComRenda">
        <span usu-error>{{ gerarMensagemErro('cpf')}}</span>
      </usucampeao-input>

      <usucampeao-select label="Estado Civil" controlName="estadoCivil">
        <ion-select-option *ngFor="let estadoCivil of estadosCivis" [value]="estadoCivil">{{ estadoCivil | estadoCivil
          }}</ion-select-option>

        <span usu-error>{{ gerarMensagemErro('estadoCivil') }}</span>
      </usucampeao-select>

      <usucampeao-input controlName="renda" label="Renda declarada*" type="tel" inputmode="numeric" mask="currency">
        <span usu-error>{{ gerarMensagemErro('renda')}}</span>
      </usucampeao-input>

      <usucampeao-input controlName="profissao" label="Profissão*" type="text">
        <span usu-error>{{ gerarMensagemErro('profissao')}}</span>
      </usucampeao-input>
    </form>

    <usucampeao-footer>
      <ion-button class="ion-margin-vertical" mode="md" (click)="submit()">
        Salvar
      </ion-button>
      <ion-button mode="md" fill="outline" type="button" (click)="voltar()">
        Cancelar
      </ion-button>
    </usucampeao-footer>
  </section>
</ion-content>